import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Collapse,
  Form,
  Input,
  Label,
  Button,
  FormFeedback,
  Modal,
  TabContent,
  TabPane,
  NavLink,
  NavItem,
  Nav,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { getMadridCrawlInfoList } from "../../store/actions";
import PeriodBtn from "../../components/Filter/PeriodBtn";
import { useEffect } from "react";

function MadridCrawlInfo({ toggle, activeTab, isOpen, tabId }) {

  const dispatch = useDispatch();

  const { noticeStr, totalPage, madridCrawlInfoList, madridRemaining, madridPdfRemaining } = useSelector(state => ({
    noticeStr: state.admDataManagement.noticeStrMadrid,
    totalPage: state.admDataManagement.totalPageMadrid,
    madridCrawlInfoList: state.admDataManagement.madridCrawlInfoList,
    madridRemaining: state.admDataManagement.madridRemaining,
    madridPdfRemaining: state.admDataManagement.madridPdfRemaining,
  }))

  const filterValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      submitType: "view",

      perPage: 20,
      curPage: 1,
      datePeriod: "",
      fromDate: "",
      toDate: "",
    },

    onSubmit: (values) => {

      const filterParam = {
        limit: values["perPage"],
        curPage: values["curPage"],
        fromDate: values.fromDate?.replace(/-/g, "") ?? "",
        toDate: values.toDate?.replace(/-/g, "") ?? "",
      };

      let submitType = values["submitType"];

      if (submitType === "view") {
        console.log(filterParam)
        dispatch(getMadridCrawlInfoList(filterParam));
      }
    }
  })

  const onPageChange = (curPage, perPage) => {
    filterValidation.setFieldValue("submitType", "view");

    if (curPage) {
      // setCurPageInput(curPage);
      filterValidation.setFieldValue("curPage", curPage);
    } else {
      // setCurPageInput(1);
      filterValidation.setFieldValue("curPage", 1);
    }

    if (perPage) {
      filterValidation.setFieldValue("perPage", perPage);
    }

    filterValidation.handleSubmit(filterValidation.values);
  }

  return (
    <TabPane style={activeTab === tabId ? {display: "block"} : {display: "none"}} tabId={tabId}>
      <Row>
        <Col lg={12}>
          <Card>
            <Link onClick={toggle} className="text-dark" to="#">
              <div className="p-4">
                <Media className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-3">
                    <i className="uil uil-file-copy-alt text-primary h2"></i>
                  </div>
                  <div className="flex-grow-1 overflow-hidden">
                    <h5 className="font-size-16 mb-1">Data Management</h5>
                  </div>
                  <i className="uil uil-filter font-size-24 text-muted"></i>
                </Media>
              </div>
            </Link>
            <Collapse isOpen={isOpen}>
              <div className="p-4 border-top">
                <Row>
                  <label htmlFor="inscribedDate" className="col-md-1 col-form-label" style={{ paddingTop: '0px' }}>
                    Date
                  </label>
                  <div className="col-md-11">
                    <PeriodBtn
                      formik={filterValidation}
                    />
                  </div>
                </Row>
                <Row >
                  <Col md={2}>&nbsp;</Col>
                  <Col md={3}>&nbsp;</Col>
                  <Col md={3}>
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light col-md-5"
                      onClick={() => {
                        filterValidation.setFieldValue("curPage", 1);
                        filterValidation.setFieldValue("submitType", "view");
                        filterValidation.handleSubmit(filterValidation.values);
                      }}
                    >
                      Search
                    </button>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </Card>
        </Col>
      </Row>
      {
        noticeStr &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="text-muted mb-0">
                  <p style={{ whiteSpace: "pre" }}>
                    {noticeStr}
                  </p>
                </CardTitle>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
      {
        Array.isArray(madridCrawlInfoList) && madridCrawlInfoList.length > 0 &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table mb-0">
                    <thead>
                      <tr>
                        <th style={{verticalAlign: "center", textAlign: "center", paddingInline: "0"}}>Date</th>
                        <th style={{verticalAlign: "center", textAlign: "center"}}>FTP(t)</th>
                        <th style={{verticalAlign: "center", textAlign: "center", paddingInline: "0"}}>FTP</th>
                        <th style={{verticalAlign: "center", textAlign: "center"}}>Sample PDF</th>
                        <th style={{verticalAlign: "center", textAlign: "center", paddingInline: "0"}}>DRU(t)</th>
                        <th style={{verticalAlign: "center", textAlign: "center"}}>DRU</th>
                        <th style={{verticalAlign: "center", textAlign: "center", paddingInline: "0"}}>Global subs</th>
                        <th style={{verticalAlign: "center", textAlign: "center"}}>
                          Remain:{madridRemaining}&nbsp;
                          <span>
                            <i className="uil uil-info-circle font-size-15" id={"madrid-remaining-info"}></i>
                            <UncontrolledTooltip placement="right" target={"madrid-remaining-info"} className="domain-correct-tooltip">
                              Applied -1 to remaining for 1271051-20250325-CN
                            </UncontrolledTooltip>
                          </span>
                          <br/>
                          Error:{madridPdfRemaining}
                        </th>
                        <th style={{verticalAlign: "center", textAlign: "center", paddingInline: "0"}}>Remain PDF</th>
                        <th style={{verticalAlign: "center", textAlign: "center"}}>Domain</th>
                        <th style={{verticalAlign: "center", textAlign: "center", paddingInline: "0"}}>Email add</th>
                        <th style={{verticalAlign: "center", textAlign: "center"}}>SA</th>
                        <th style={{verticalAlign: "center", textAlign: "center", paddingInline: "0"}}>SA (t)</th>
                        <th style={{verticalAlign: "center", textAlign: "center"}}>Full user info</th>
                        <th style={{verticalAlign: "center", textAlign: "center", paddingInline: "0"}}>WAR</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        madridCrawlInfoList.map((info, index) => {
                          return (
                            <tr key={info.crawlDate}>
                              <td style={{textAlign: 'center'}}>{`${info.crawlDate.substring(0, 4)}/${info.crawlDate.substring(4, 6)}/${info.crawlDate.substring(6, 8)}`}</td>
                              <td style={{textAlign: 'center'}}>{info.ftpTime || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.ftpCount || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.samplePdfTime || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.druTime || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.druCount || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.globalSubsCount || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.remainingPdfTime || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.remainingPdfCount || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.domainTime || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.emailAddressTime || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.saStatus || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.saRestartedTime || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.fullUserInfoTime || "-"}</td>
                              <td style={{textAlign: 'center'}}>{info.warTime || "-"}</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </Table>
                </div>
                <div className="d-flex justify-content-between" style={{ marginTop: "20px" }}>
                  <span className="d-flex align-items-center gap-2">
                    <label
                      htmlFor="perPage"
                    >
                      Entries per page
                    </label>
                    <div style={{ width: "100px" }}>
                      <select
                        className="form-select"
                        name="perPage"
                        onChange={e => { onPageChange(1, e.target.value); }}
                        value={filterValidation.values.perPage}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                  </span>
                  <span className="d-flex align-items-center gap-2">
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<<"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) - 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<"}
                      </Button>
                    </div>
                    Page{" "}
                    <strong>
                      {filterValidation.values.curPage} of {totalPage}
                    </strong>

                    <Input
                      type="number"
                      min={1}
                      style={{ width: 70 }}
                      max={totalPage}
                      name="curPage"
                      defaultValue={filterValidation.values.curPage}
                      value={filterValidation.values.curPage}
                      onChange={(e) => { 
                        const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                        // setCurPageInput(_curPage, totalPage)
                        filterValidation.setFieldValue("curPage", _curPage);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                          onPageChange(_curPage, filterValidation.values.perPage);
                        }
                      }}
                    />
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) + 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(totalPage, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">>"}
                      </Button>
                    </div>
                  </span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
    </TabPane>
  )
}

export default MadridCrawlInfo;